export interface Movie {
  id: string;
  title: string;
  category: string;
  subtype: string;
  year: number;
  rating: number;
  description: string;
  image: string;
  tags: string[];
  director: string;
  actors: string[];
  region: string;
  duration: string;
  releaseDate: string;
  updateDate: string;
  views: number;
  isHot: boolean;
  isNew: boolean;
  quality: string;
}

export const movieCategories = [
  { key: 'movie', name: '电影', icon: 'ri-movie-2-line' },
  { key: 'tv', name: '电视剧', icon: 'ri-tv-2-line' },
  { key: 'variety', name: '综艺', icon: 'ri-live-line' },
  { key: 'anime', name: '动漫', icon: 'ri-ancient-gate-line' },
  { key: 'documentary', name: '纪录片', icon: 'ri-film-line' },
];

export const movies: Movie[] = [
  {
    id: '1',
    title: '流浪地球3',
    category: 'movie',
    subtype: '科幻',
    year: 2026,
    rating: 8.5,
    description: '在太阳急速衰老膨胀的背景下，人类面临前所未有的生存危机。联合政府启动"流浪地球计划"，带着地球逃离太阳系，前往4.2光年外的新家园。第三部讲述了地球在穿越小行星带时遭遇的惊心动魄的冒险历程，人类的勇气与智慧在这场宇宙迁徙中再次经受考验。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20Earth%20engines%20in%20space%2C%20dramatic%20lighting%2C%20cinematic%20epic%20scale%2C%20dark%20atmosphere%20with%20blue%20glow%2C%20clean%20composition%2C%20movie%20poster%20style&width=800&height=1120&seq=movie-1&orientation=portrait',
    tags: ['科幻', '灾难', '冒险', '国产'],
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    region: '中国大陆',
    duration: '173分钟',
    releaseDate: '2026-02-01',
    updateDate: '2026-08-09',
    views: 1580000,
    isHot: true,
    isNew: false,
    quality: '4K',
  },
  {
    id: '2',
    title: '封神第二部：战火西岐',
    category: 'movie',
    subtype: '奇幻',
    year: 2025,
    rating: 8.2,
    description: '殷商末年，纣王暴政，天下大乱。姬发率领西岐军民奋起反抗，姜子牙携封神榜下山辅佐。神仙妖魔纷纷登场，一场惊天动地的封神大战拉开帷幕。影片以宏大的战争场面和精致的特效，再现了中国神话的无穷魅力。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20mythology%20movie%20poster%20with%20ancient%20warriors%20and%20mythical%20creatures%2C%20epic%20battle%20scene%2C%20golden%20and%20red%20tones%2C%20cinematic%20lighting%2C%20dramatic%20composition&width=800&height=1120&seq=movie-2&orientation=portrait',
    tags: ['奇幻', '古装', '神话', '动作'],
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰'],
    region: '中国大陆',
    duration: '148分钟',
    releaseDate: '2025-07-12',
    updateDate: '2026-08-08',
    views: 1250000,
    isHot: true,
    isNew: false,
    quality: '4K',
  },
  {
    id: '3',
    title: '哪吒之魔童闹海',
    category: 'anime',
    subtype: '动画',
    year: 2025,
    rating: 8.9,
    description: '天劫之后，哪吒和敖丙的灵魂虽保住了，但肉身面临消散的危险。太乙真人打算用七色宝莲为二人重塑肉身，然而在此过程中却遭遇重重困难。哪吒与敖丙的命运将何去何从？一场关于成长、友情与勇气的传奇故事就此展开。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20mythical%20boy%20character%20with%20fire%20elements%2C%20vibrant%20red%20and%20gold%20colors%2C%20dynamic%20action%20pose%2C%20cinematic%20anime%20style%2C%20epic%20composition&width=800&height=1120&seq=movie-3&orientation=portrait',
    tags: ['动画', '奇幻', '神话', '喜剧'],
    director: '饺子',
    actors: ['吕艳婷', '陈浩', '囧森瑟夫'],
    region: '中国大陆',
    duration: '144分钟',
    releaseDate: '2025-01-29',
    updateDate: '2026-08-07',
    views: 2100000,
    isHot: true,
    isNew: false,
    quality: '4K',
  },
  {
    id: '4',
    title: '狂飙',
    category: 'tv',
    subtype: '犯罪',
    year: 2023,
    rating: 8.7,
    description: '讲述了以一线刑警安欣为代表的正义力量，与黑恶势力展开的长达二十年的生死较量。通过群像叙事展现扫黑行动中的复杂人性与艰难抉择，深刻揭示了扫黑除恶工作的艰巨性和复杂性。全剧剧情紧凑，演技炸裂，是近年来国产剧集的标杆之作。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20with%20police%20officer%20silhouette%20against%20city%20night%2C%20dark%20moody%20atmosphere%2C%20noir%20style%2C%20cinematic%20lighting%2C%20tense%20composition&width=800&height=1120&seq=movie-4&orientation=portrait',
    tags: ['犯罪', '剧情', '扫黑', '国产'],
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    region: '中国大陆',
    duration: '39集',
    releaseDate: '2023-01-14',
    updateDate: '2026-08-09',
    views: 3200000,
    isHot: true,
    isNew: false,
    quality: '1080P',
  },
  {
    id: '5',
    title: '长安十二时辰',
    category: 'tv',
    subtype: '古装',
    year: 2019,
    rating: 8.3,
    description: '上元节前夕，长安城混入可疑人员，身陷囹圄的张小敬临危受命，与少年天才李必携手在十二个时辰内破除隐患、拯救长安城。全剧以精巧的叙事结构和极致的美术呈现，还原了盛唐长安的恢弘气象。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20ancient%20Tang%20dynasty%20cityscape%2C%20warm%20golden%20lantern%20light%2C%20palace%20architecture%2C%20cinematic%20composition%2C%20elegant%20Chinese%20aesthetic&width=800&height=1120&seq=movie-5&orientation=portrait',
    tags: ['古装', '悬疑', '历史', '动作'],
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    region: '中国大陆',
    duration: '48集',
    releaseDate: '2019-06-27',
    updateDate: '2026-08-05',
    views: 980000,
    isHot: true,
    isNew: false,
    quality: '4K',
  },
  {
    id: '6',
    title: '独行月球',
    category: 'movie',
    subtype: '喜剧',
    year: 2022,
    rating: 7.8,
    description: '人类为抵御小行星撞击，在月球部署了月盾计划。陨石提前来袭，全员紧急撤离时，维修工独孤月因意外错过撤离通知，一个人被落在了月球。不料月盾计划失败，独孤月成为了"宇宙最后的人类"，开始了他在月球上的破罐破摔的生活。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20sci-fi%20movie%20poster%20with%20astronaut%20on%20moon%20surface%2C%20humorous%20tone%2C%20starry%20space%20background%2C%20cinematic%20lighting%2C%20clean%20composition&width=800&height=1120&seq=movie-6&orientation=portrait',
    tags: ['喜剧', '科幻', '剧情'],
    director: '张吃鱼',
    actors: ['沈腾', '马丽', '黄才伦', '常远'],
    region: '中国大陆',
    duration: '122分钟',
    releaseDate: '2022-07-29',
    updateDate: '2026-08-06',
    views: 1890000,
    isHot: false,
    isNew: false,
    quality: '4K',
  },
  {
    id: '7',
    title: '三体',
    category: 'tv',
    subtype: '科幻',
    year: 2023,
    rating: 8.1,
    description: '21世纪初，地球基础科学研究遭遇异常干扰。纳米科学家汪淼被警官史强带到联合作战中心，由此接触到"科学边界"组织。随着调查深入，汪淼发现一个名为"三体"的外星文明正在逼近地球，人类的命运悬于一线。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20abstract%20three-body%20problem%20visual%2C%20cosmic%20scale%2C%20dark%20mysterious%20atmosphere%2C%20minimalist%20design%2C%20cinematic%20quality&width=800&height=1120&seq=movie-7&orientation=portrait',
    tags: ['科幻', '剧情', '悬疑', '国产'],
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    region: '中国大陆',
    duration: '30集',
    releaseDate: '2023-01-15',
    updateDate: '2026-08-08',
    views: 1450000,
    isHot: false,
    isNew: true,
    quality: '4K',
  },
  {
    id: '8',
    title: '王牌对王牌 第八季',
    category: 'variety',
    subtype: '综艺',
    year: 2025,
    rating: 7.5,
    description: '浙江卫视推出的原创室内竞技真人秀节目。每期围绕一个主题，邀请两支王牌团队通过才艺比拼、游戏竞技等多种形式进行PK对决。节目以轻松欢乐的氛围、爆笑的游戏环节和精彩的才艺表演，为观众带来无限欢乐。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20colorful%20game%20show%20elements%2C%20entertaining%20atmosphere%2C%20bright%20stage%20lighting%2C%20celebrity%20guests%2C%20fun%20energetic%20composition&width=800&height=1120&seq=movie-8&orientation=portrait',
    tags: ['综艺', '真人秀', '喜剧'],
    director: '吴彤',
    actors: ['沈腾', '贾玲', '华晨宇', '关晓彤', '宋亚轩'],
    region: '中国大陆',
    duration: '12期',
    releaseDate: '2025-03-15',
    updateDate: '2026-08-09',
    views: 860000,
    isHot: false,
    isNew: true,
    quality: '1080P',
  },
  {
    id: '9',
    title: '满江红',
    category: 'movie',
    subtype: '悬疑',
    year: 2023,
    rating: 7.9,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一名小兵与亲兵营副统领机缘巧合被卷进这场巨大阴谋之中，宰相秦桧命两人限一个时辰之内找到凶手。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20movie%20poster%20with%20ancient%20Song%20dynasty%20courtyard%2C%20dark%20red%20and%20black%20tones%2C%20suspenseful%20atmosphere%2C%20cinematic%20lighting%2C%20dramatic%20shadows&width=800&height=1120&seq=movie-9&orientation=portrait',
    tags: ['悬疑', '古装', '剧情', '喜剧'],
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    region: '中国大陆',
    duration: '159分钟',
    releaseDate: '2023-01-22',
    updateDate: '2026-08-04',
    views: 1750000,
    isHot: false,
    isNew: false,
    quality: '4K',
  },
  {
    id: '10',
    title: '地球脉动 第三季',
    category: 'documentary',
    subtype: '自然',
    year: 2023,
    rating: 9.6,
    description: 'BBC自然纪录片系列的巅峰之作。从海洋深处到冰雪极地，从丛林秘境到沙漠戈壁，镜头带领观众领略地球上最壮丽的自然奇观和野生动物的生存故事。每一帧画面都是视觉饕餮，每一个故事都令人叹为观止。',
    image: 'https://readdy.ai/api/search-image?query=nature%20documentary%20poster%20with%20stunning%20wildlife%20and%20landscapes%2C%20Earth%20from%20space%20view%2C%20vibrant%20natural%20colors%2C%20cinematic%20quality%2C%20awe-inspiring%20composition&width=800&height=1120&seq=movie-10&orientation=portrait',
    tags: ['自然', '纪录', 'BBC', '高分'],
    director: '大卫·爱登堡',
    actors: ['大卫·爱登堡'],
    region: '英国',
    duration: '8集',
    releaseDate: '2023-10-22',
    updateDate: '2026-08-07',
    views: 720000,
    isHot: false,
    isNew: false,
    quality: '4K',
  },
  {
    id: '11',
    title: '铃芽之旅',
    category: 'anime',
    subtype: '动画',
    year: 2023,
    rating: 7.7,
    description: '生活在九州乡间的17岁少女铃芽，某天遇到了为寻找"门"而四处旅行的青年草太。追随着青年的脚步，铃芽来到山上一片废墟之地，在那里发现了一扇古老的门。仿佛被某种力量牵引般，铃芽将手伸向了那扇门...一段关于成长与治愈的奇幻旅程就此展开。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20with%20young%20girl%20and%20mysterious%20door%20in%20ruins%2C%20beautiful%20sky%20and%20landscape%2C%20warm%20color%20palette%2C%20cinematic%20anime%20style%2C%20emotional%20composition&width=800&height=1120&seq=movie-11&orientation=portrait',
    tags: ['动画', '奇幻', '冒险', '治愈'],
    director: '新海诚',
    actors: ['原菜乃华', '松村北斗', '深津绘里'],
    region: '日本',
    duration: '122分钟',
    releaseDate: '2023-03-24',
    updateDate: '2026-08-06',
    views: 890000,
    isHot: false,
    isNew: false,
    quality: '1080P',
  },
  {
    id: '12',
    title: '狂野非洲',
    category: 'documentary',
    subtype: '自然',
    year: 2025,
    rating: 8.8,
    description: '深入非洲大陆腹地，记录塞伦盖蒂大迁徙、刚果雨林秘境和撒哈拉沙漠边缘的生命奇迹。耗时五年拍摄，以最前沿的摄影技术捕捉了非洲野生动物最真实、最震撼的生存状态。这是一部献给自然与生命的影像赞歌。',
    image: 'https://readdy.ai/api/search-image?query=African%20wildlife%20documentary%20poster%20with%20lions%20and%20elephants%20on%20savanna%20sunset%2C%20dramatic%20golden%20hour%20lighting%2C%20cinematic%20nature%20photography%2C%20epic%20composition&width=800&height=1120&seq=movie-12&orientation=portrait',
    tags: ['自然', '动物', '非洲', '纪录'],
    director: '陆川',
    actors: [],
    region: '中国大陆',
    duration: '98分钟',
    releaseDate: '2025-06-15',
    updateDate: '2026-08-05',
    views: 450000,
    isHot: false,
    isNew: true,
    quality: '4K',
  },
  {
    id: '13',
    title: '奔跑吧 第十二季',
    category: 'variety',
    subtype: '综艺',
    year: 2025,
    rating: 7.2,
    description: '浙江卫视推出的户外竞技真人秀节目。常驻嘉宾与飞行嘉宾组成团队，前往全国各地完成各种趣味挑战任务。节目以积极向上的精神、幽默搞笑的互动和美丽的风景，陪伴观众度过愉快的周末时光。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20outdoor%20variety%20show%20poster%20with%20running%20celebrities%2C%20bright%20sunny%20outdoor%20scene%2C%20energetic%20and%20fun%20atmosphere%2C%20colorful%20design%2C%20entertaining%20composition&width=800&height=1120&seq=movie-13&orientation=portrait',
    tags: ['综艺', '真人秀', '户外', '竞技'],
    director: '姚译添',
    actors: ['李晨', '郑恺', '杨颖', '沙溢', '白鹿', '周深'],
    region: '中国大陆',
    duration: '12期',
    releaseDate: '2025-04-18',
    updateDate: '2026-08-08',
    views: 1050000,
    isHot: false,
    isNew: false,
    quality: '1080P',
  },
  {
    id: '14',
    title: '间谍过家家 第二季',
    category: 'anime',
    subtype: '动画',
    year: 2023,
    rating: 8.6,
    description: '为了执行维护东西和平的秘密任务，最强的间谍黄昏组建了一个临时家庭。但他不知道的是，女儿阿尼亚是超能力者，妻子约尔是职业杀手。三人互相隐藏着真实身份，却在相处中逐渐产生了真正的亲情羁绊。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20spy%20family%20poster%20with%20stylish%20characters%2C%20elegant%20design%2C%20warm%20family%20theme%2C%20action%20elements%2C%20cinematic%20anime%20composition&width=800&height=1120&seq=movie-14&orientation=portrait',
    tags: ['动画', '喜剧', '动作', '日常'],
    director: '古桥一浩',
    actors: ['江口拓也', '种崎敦美', '早见沙织'],
    region: '日本',
    duration: '25集',
    releaseDate: '2023-10-07',
    updateDate: '2026-08-07',
    views: 980000,
    isHot: true,
    isNew: false,
    quality: '1080P',
  },
  {
    id: '15',
    title: '奥本海默',
    category: 'movie',
    subtype: '传记',
    year: 2023,
    rating: 8.8,
    description: '讲述了美国"原子弹之父"罗伯特·奥本海默在二战期间主导制造世界上第一颗原子弹的故事。影片深入探讨了科学与道德、权力与责任的深刻命题，以震撼的视听语言呈现了人类历史上最具决定性的时刻。',
    image: 'https://readdy.ai/api/search-image?query=Oppenheimer%20movie%20poster%20style%20with%20mushroom%20cloud%20and%20scientist%20silhouette%2C%20dramatic%20black%20and%20orange%20tones%2C%20cinematic%20lighting%2C%20intense%20atmosphere%2C%20minimalist%20composition&width=800&height=1120&seq=movie-15&orientation=portrait',
    tags: ['传记', '历史', '剧情', '战争'],
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    region: '美国',
    duration: '180分钟',
    releaseDate: '2023-07-21',
    updateDate: '2026-08-05',
    views: 1320000,
    isHot: false,
    isNew: false,
    quality: '4K',
  },
  {
    id: '16',
    title: '中国奇谭',
    category: 'anime',
    subtype: '动画',
    year: 2023,
    rating: 8.4,
    description: '由八个植根于中国传统文化的独立故事组成，涵盖多种美术风格和制作手法。从古代到现代，从乡土到科幻，每个故事都展现了独特的中国美学和哲思，是对中国动画多样性的一次精彩探索。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20painting%20style%20animation%20poster%20with%20mythical%20creatures%2C%20traditional%20Chinese%20art%20aesthetic%2C%20elegant%20brushwork%2C%20cultural%20themes%2C%20artistic%20composition&width=800&height=1120&seq=movie-16&orientation=portrait',
    tags: ['动画', '奇幻', '国风', '独立'],
    director: '陈廖宇',
    actors: [],
    region: '中国大陆',
    duration: '8集',
    releaseDate: '2023-01-01',
    updateDate: '2026-08-04',
    views: 760000,
    isHot: false,
    isNew: false,
    quality: '1080P',
  },
];

export const faqData = [
  {
    question: '秋霞影院是否需要注册才能观看？',
    answer: '不需要！秋霞影院致力于为所有用户提供便捷的观影体验，您无需注册或登录账号即可直接在线观看所有影片资源。我们始终坚持免费开放的原则，让每一位影迷都能轻松畅享高清画质的影视内容。',
  },
  {
    question: '秋霞影院的影片画质如何？',
    answer: '我们提供从720P到4K多种清晰度选择，大部分热门影片均支持1080P高清和4K超高清画质。您可以根据自己的网络环境和设备性能，自由切换最适合的清晰度，确保流畅且优质的观影体验。',
  },
  {
    question: '支持哪些设备观看秋霞影院？',
    answer: '秋霞影院采用先进的响应式技术，完美适配电脑、平板、手机等多种终端设备。无论是Windows、Mac、iOS还是Android系统，只需打开浏览器访问我们的网站即可畅快观影，无需下载任何APP。',
  },
  {
    question: '影片资源多久更新一次？',
    answer: '我们设有专业的资源更新团队，每天24小时不间断更新最新影视资源。院线新片下映后通常在1-2周内即可上线，热门电视剧和综艺节目基本做到同步更新，确保您不会错过任何精彩内容。',
  },
  {
    question: '观看过程中遇到卡顿怎么办？',
    answer: '您可以尝试以下方法：1）切换至较低清晰度（如从4K降至1080P）；2）暂停视频缓冲片刻后再播放；3）检查您的网络连接状态；4）刷新页面重新加载。如问题持续存在，欢迎通过"关于我们"页面的联系方式反馈，我们会及时优化服务器。',
  },
  {
    question: '秋霞影院的影片资源是否正版？',
    answer: '秋霞影院作为影视资源聚合平台，致力于为用户提供便捷的观影入口。我们严格遵守相关法律法规，积极推动正版内容的传播。如您是版权方且对我们的内容有异议，请通过"关于我们"页面的联系方式与我们沟通，我们将第一时间处理。',
  },
];

export const testimonials = [
  {
    name: '电影爱好者小李',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20young%20Chinese%20man%2C%20studio%20lighting%2C%20clean%20white%20background%2C%20friendly%20expression&width=100&height=100&seq=avatar-1&orientation=squarish',
    rating: 5,
    content: '用了秋霞影院半年多了，更新速度真的快，画质也很清晰。相比其他平台动不动就要会员，这里完全免费简直太良心了！',
  },
  {
    name: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20Chinese%20woman%20in%20her%2020s%2C%20studio%20lighting%2C%20clean%20white%20background%2C%20warm%20smile&width=100&height=100&seq=avatar-2&orientation=squarish',
    rating: 5,
    content: '每天晚上睡前必刷秋霞影院，资源真的太全了！国产剧、日剧、韩剧应有尽有，而且分类清晰，找片特别方便。',
  },
  {
    name: '资深影迷老张',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20middle-aged%20Chinese%20man%2C%20studio%20lighting%2C%20clean%20white%20background%2C%20confident%20expression&width=100&height=100&seq=avatar-3&orientation=squarish',
    rating: 4,
    content: '作为看了二十年电影的老影迷，秋霞影院的片库深度让我很惊喜。很多冷门佳片和经典老片都能找到，4K修复版的老电影画质完全不输新片。',
  },
];

export const siteInfo = {
  name: '秋霞影院',
  description: '秋霞影院提供海量高清电影、电视剧、综艺免费在线观看，资源更新快、画质清晰、无需注册即可畅享。秋霞影院是您追剧看片的首选平台，支持多终端流畅播放，每日更新最新影视资源。',
  keywords: '秋霞影院,秋霞电影,免费在线观影,高清电影,电视剧在线看,秋霞影视,最新电影免费看',
  email: 'contact@qiuxiayy.com',
  founded: '2018',
  totalMovies: '50000+',
  dailyVisitors: '100万+',
};